import uploadssettingsheaddefaulticonabLogo512Png from "$lib/data/generated/uploads/settings/Head/defaultIcon/ab-logo-512.png";
import uploadssettingsheaddefaultimageabHeroImageMocks28129Png from "$lib/data/generated/uploads/settings/Head/defaultImage/AB-Hero-Image-Mocks--281-29.png";

export const uploads = {
  "uploads/settings/Head/defaultIcon/ab-logo-512.png": uploadssettingsheaddefaulticonabLogo512Png,
  "uploads/settings/Head/defaultImage/AB-Hero-Image-Mocks--281-29.png": uploadssettingsheaddefaultimageabHeroImageMocks28129Png
};